import { DropdownPrimeReact } from "@finanedi.es/storybook"
import { GetAllImpuestosDtoProps } from "api/DTOs/GetAllImpuestosDto"
import { useImpuestoEmpresaNew } from "api/ImpuestoEmpresa.hook"
import { GetAllImpuestosDtoIPagedEnumerableProps } from "api/Schemas/GetAllImpuestosDtoIPagedEnumerable"
import { TIPO_GRUPO_IMPUESTO } from "api/Types/TipoGrupoImpuesto"
import { TIPO_IMPUESTO_EMPRESA_ENUM } from "api/Types/TipoImpuestoEmpresaEnum"
import { InputNumber } from "primereact/inputnumber"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"

const ImpuestosForm = ({
  values,
  setFieldValue,
  dropdownId,
  inputId,
  title,
  isRetencion = false,
  isLibrado,
  isLibradoDoc,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()

  const {
    impuestoEmpresa,
    impuestoEmpresaIsLoading,
  }: {
    impuestoEmpresa?: GetAllImpuestosDtoIPagedEnumerableProps
    impuestoEmpresaIsLoading: boolean
  } = useImpuestoEmpresaNew({
    EmpresaId: values?.empresaActiva?.id,
    TipoGrupoImpuesto: isRetencion
      ? TIPO_GRUPO_IMPUESTO.IMPUESTO_RETENIDO
      : TIPO_GRUPO_IMPUESTO.IMPUESTO_REPERCUTIDO,
    TipoImpuestoEmpresa:
      isLibrado || isLibradoDoc
        ? TIPO_IMPUESTO_EMPRESA_ENUM.COMPRA
        : TIPO_IMPUESTO_EMPRESA_ENUM.VENTA,
    EsActivo: true,
    IsPagingEnabled: false,
  })

  const handleSetValues = useCallback(
    (dropdownId: string, value: string) => {
      setFieldValue(dropdownId, value)
      const localValue = impuestoEmpresa?.items?.find(
        (val: GetAllImpuestosDtoProps) => value === val.id
      )
      if (localValue) {
        setFieldValue(inputId, Math.abs(localValue.valor))
      } else setFieldValue(inputId, 0)
    },
    [impuestoEmpresa, inputId, setFieldValue]
  )

  return (
    <>
      <label htmlFor='retencion'>{title}</label>
      <DropdownPrimeReact
        options={impuestoEmpresa?.items ?? []}
        loading={impuestoEmpresaIsLoading}
        optionValue='id'
        optionLabel='nombre'
        value={values[dropdownId]}
        onChange={(e) => handleSetValues(dropdownId, e.value)}
        id={dropdownId}
        name={dropdownId}
        placeholder={`${t("impuestos.placeholderType")}`}
        panelClassName='!tw-z-50'
      />

      <InputNumber
        className='mt-2'
        name={inputId}
        disabled
        suffix='%'
        value={Math.abs(parseInt(values[inputId], 10))}
        useGrouping={false}
      />
    </>
  )
}

export default ImpuestosForm
